import React from "react";
import { useSelector } from "react-redux";

import "./index.scss";
import { useGetInvoicesQuery } from "store/invoice/invoiceApi";
import { useGetQuotesQuery } from "store/quote/quoteApi";
import { useGetAvoirsQuery } from "store/avoir/avoir.api";

const DashboardUser = () => {
  const user = useSelector((state) => state.auth.user);
  const companyId = user?.companyId?._id;

  // ✅ Fetch all three datasets
  const { data: invoicesData, isLoading: invoicesLoading } =
    useGetInvoicesQuery(companyId, {
      skip: !companyId,
    });
  const { data: quotesData, isLoading: quotesLoading } = useGetQuotesQuery(
    { companyId },
    {
      skip: !companyId,
    }
  );
  const { data: avoirsData, isLoading: avoirsLoading } = useGetAvoirsQuery(
    companyId,
    {
      skip: !companyId,
    }
  );

  // ✅ Extract counts safely
  const invoicesCount = invoicesData?.data?.length || 0;
  const quotesCount = quotesData?.data?.length || 0;
  const avoirsCount = avoirsData?.data?.length || 0;

  const isLoading = invoicesLoading || quotesLoading || avoirsLoading;

  return (
    <div className="dashboard-container">
      <h2 className="dashboard-title">📊 Tableau de bord</h2>

      {isLoading ? (
        <div className="loader">Chargement des données...</div>
      ) : (
        <div className="cards-container">
          <div className="dashboard-card invoices">
            <h3>📄 Factures</h3>
            <p className="count">{invoicesCount}</p>
            <span className="card-subtitle">Total des factures</span>
          </div>

          <div className="dashboard-card quotes">
            <h3>📝 Devis</h3>
            <p className="count">{quotesCount}</p>
            <span className="card-subtitle">Total des devis</span>
          </div>

          <div className="dashboard-card avoirs">
            <h3>💶 Avoirs</h3>
            <p className="count">{avoirsCount}</p>
            <span className="card-subtitle">Total des avoirs</span>
          </div>
        </div>
      )}
    </div>
  );
};

export default DashboardUser;
